var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('v-layout', {
    staticClass: "h-100 text-center",
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("미팅생성이 완료되었습니다.")]), _c('p', {
    staticClass: "page-text--lg grey-6--text mb-8 mb-lg-16"
  }, [_vm._v(" 해당 URL을 담당 지원자와 공유하여 미팅일정을 잡아주세요. "), _c('br'), _vm._v(" 해당 URL을 빠르게 공유하려면 문자서비스를 이용해보세요. ")]), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "rounded": "",
      "large": "",
      "color": "grey-f1"
    },
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.matchUrl);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.matchUrl) + " ")]), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("나가기")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, [_c('span', [_vm._v("문자로 정보 발송")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }